define('directives/common/stepNavigator/stepNavigator.directive',['app'], function (app) {
    app.directive('stepNavigator', ['$state','$transitions', function ($state,$transitions) {
        return {
            restrict: 'EA',
            scope: {
                conf: '='
            },
            templateUrl: 'directives/common/stepNavigator/stepNavigator.html',
            link: function (scope, element, attrs) {
                scope.$watch('conf',function(val){
                    if (val) scope.itemWidth = {width: scope.conf.length ? (100 / scope.conf.length) + '%' : '100%'};//set the width of each step
                    setStatus($state.$current);
                })

                function setStatus(currentState) {
                    var curStepInd = 0;
                    angular.forEach(scope.conf, function (item, ind) {
                        if (AUI.BaseJSUtil.contains(item.mapState,currentState.name)) curStepInd = ind;
                    });

                    angular.forEach(scope.conf, function (item, ind) {
                        if (AUI.BaseJSUtil.contains(item.mapState,currentState.name)) {
                        	if(currentState.name == 'rollout.submitSuccess'){
                        		item.finished = true;
                                item.visiting = false;
                        	}else{
                        		item.finished = false;
                                item.visiting = true;
                        	}
                            
                        }
                        if (curStepInd < ind) {
                            scope.conf[ind].finished = false;
                            scope.conf[ind].visiting = false;
                        }

                        if (curStepInd > ind) {
                            scope.conf[ind].finished = true;
                            scope.conf[ind].visiting = false;
                        }
                    });
                    if(document.getElementById('step-flow')) document.getElementById('step-flow').scrollTop = 0;
                }

                $transitions.onSuccess({},function(){setStatus($state.$current);});
            }
        };
    }]);
});
